/**
 * 用户类型标识
 *
 * - 企业用户显示一个企业徽章
 */

import classNames from 'classnames'
import { CopyrightUserType } from '~/graphqls/types'

export default function UserBadge({
  type,
  className,
}: {
  type: CopyrightUserType | null | undefined
  className?: string
}) {
  if (type === CopyrightUserType.COMPANY) {
    return (
      <span
        className={classNames(
          className,
          'inline-block leading-none align-text-bottom w-6 h-6'
        )}
      >
        <svg
          className="w-full h-full"
          width="25"
          height="28"
          viewBox="0 0 25 28"
          fill="none"
        >
          <path
            d="M10.5 3.15455C11.7376 2.44002 13.2624 2.44002 14.5 3.15455L20.8923 6.84515C22.1299 7.55968 22.8923 8.88019 22.8923 10.3093V17.6904C22.8923 19.1195 22.1299 20.44 20.8923 21.1546L14.5 24.8451C13.2624 25.5597 11.7376 25.5597 10.5 24.8451L4.10767 21.1546C2.87006 20.44 2.10767 19.1195 2.10767 17.6904V10.3093C2.10767 8.88019 2.87006 7.55968 4.10767 6.84515L10.5 3.15455Z"
            fill="#4BC9F0"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.5 1.4225L21.8923 5.1131C23.7487 6.1849 24.8923 8.16566 24.8923 10.3093V17.6904C24.8923 19.834 23.7487 21.8148 21.8923 22.8866L15.5 26.5772C13.6436 27.649 11.3564 27.649 9.49997 26.5772L3.10767 22.8866C1.25126 21.8148 0.107666 19.834 0.107666 17.6904V10.3093C0.107666 8.16566 1.25126 6.1849 3.10767 5.1131L9.49997 1.4225C11.3564 0.350703 13.6436 0.350703 15.5 1.4225ZM14.5 3.15455C13.2624 2.44002 11.7376 2.44002 10.5 3.15455L4.10767 6.84515C2.87006 7.55968 2.10767 8.88019 2.10767 10.3093V17.6904C2.10767 19.1195 2.87006 20.44 4.10767 21.1546L10.5 24.8451C11.7376 25.5597 13.2624 25.5597 14.5 24.8451L20.8923 21.1546C22.1299 20.44 22.8923 19.1195 22.8923 17.6904V10.3093C22.8923 8.88019 22.1299 7.55968 20.8923 6.84515L14.5 3.15455Z"
            fill="#FCFCFD"
          />
          <path
            d="M12.0365 8C10.5635 9.6254 8.72222 10.9841 6.5 12.0762L7.21111 13.3714C9.42063 12.1905 11.1857 10.7937 12.519 9.19365C13.9667 10.9079 15.719 12.2921 17.7762 13.3587L18.5 12.0635C16.4175 11.073 14.5889 9.72698 13.0016 8H12.0365ZM12.2143 11.4413V18.019H10.2079V13.2698H8.9V18.019H7.09683V19.3143H17.7889V18.019H13.5476V15.3778H16.8619V14.0952H13.5476V11.4413H12.2143Z"
            fill="#FCFCFD"
          />
        </svg>
      </span>
    )
  }

  return null
}
